import React from "react";
import Grid from "@material-ui/core/Grid";

import styles from "./size-info.module.scss";
import image from "../../../assets/images/size-info/pleated_skirt.png";

function PleatedSkirt() {
  return (
    <Grid container className={styles.sizeInfo}>
      <Grid item xs={12}>
        <h2 className={styles.sizeInfoTitle}>
          Возьмите Вашу любимую юбку и проведите измерения:
        </h2>
      </Grid>
      <Grid item xs={12} md={4} className={styles.sizeInfoImage}>
        <img src={image} />
      </Grid>
      <Grid item xs={12} md={8}>
        <ol>
          <li>Измерьте ширину пояса Вашей юбки (в см).</li>
          <li>Измерьте длину юбки от пояса до низа (в см)</li>
          <li>
            В нашей таблице размеров найдите показатели, которые наиболее точно
            соответствуют получившимся цифрам.
          </li>
        </ol>
        <p>
          Если у Вас нет похожей юбки для снятия мерок, то можно измерить обхват
          талии, разделить этот результат на 2, прибавив 1-2 см к получившемуся
          и посмотреть в нашей таблице размеров. Измерить желаемую длину от
          Вашей талии и определиться с наиболее подходящим показателем в нашей
          таблице.
        </p>
      </Grid>
    </Grid>
  );
}

PleatedSkirt.propTypes = {};

export default PleatedSkirt;
